<template>
    <div>
        <a @click="closeGame()" @touchend="closeGame()" id="close-game">{{ $t('Back') }}</a>
        <InfoScreen></InfoScreen>
    </div>
</template>

<script>
export default {
    name: 'Play',
    methods: {
        closeGame() {
            window.location.replace(this.route('games.index').url());
        }
    }
}
</script>

<style lang="scss" scoped>
    #close-game {
        position: absolute;
        top: 7px;
        left: 7px;
        font-size: 1.4rem;
        background-color: black;
        color: white;
        padding: 0.2rem 0.6rem;
        border-radius: 0.2rem;
        cursor: pointer;
        z-index: 10001;
    }
</style>
